export function formatDateInputValue(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getRelativeDateRange(dayCount: number, end = new Date()): { startDate: string; endDate: string } {
  if (!Number.isInteger(dayCount) || dayCount < 1) {
    throw new RangeError('dayCount must be a positive integer');
  }

  const start = new Date(end);
  start.setDate(end.getDate() - (dayCount - 1));
  return {
    startDate: formatDateInputValue(start),
    endDate: formatDateInputValue(end),
  };
}
